import { ArrowUpRight } from "lucide-react";
import { Reveal, scrollTo } from "@/components/Reveal";

export default function Footer() {
  return (
    <footer className="overflow-hidden border-t border-white/10" data-testid="footer">
      <div className="mx-auto max-w-6xl px-6 pb-10 pt-24 text-center lg:px-10 lg:pt-32">
        <Reveal>
          <div className="flex flex-col items-center gap-8">
            <div>
              <p className="text-xs font-medium uppercase tracking-[0.35em] text-neutral-500">
                Ready when you are
              </p>
              <button
                onClick={() => scrollTo("#apply")}
                data-testid="footer-apply-cta"
                className="group mt-4 flex items-center gap-3 font-serif text-3xl font-light italic text-white transition-opacity duration-300 hover:opacity-60 sm:text-4xl"
              >
                Start your application
                <ArrowUpRight className="h-7 w-7 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </button>
            </div>
            <a
              href="https://www.youtube.com/@sergjchavez"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube-link"
              className="w-fit border border-white/30 px-6 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white hover:text-black"
            >
              YouTube — @sergjchavez
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.1} y={80}>
          <h2
            className="mt-24 select-none overflow-hidden whitespace-nowrap font-serif text-[8.5vw] font-light leading-none tracking-tight text-white/10"
            data-testid="footer-wordmark"
          >
            SERGIO CHAVEZ
          </h2>
        </Reveal>

        <div className="mt-10 flex flex-col items-center gap-3 border-t border-white/10 pt-8 text-xs uppercase tracking-[0.2em] text-neutral-600">
          <p>© {new Date().getFullYear()} Sergio Chavez. All rights reserved.</p>
          <p>Private Dating Consultant for Professionals</p>
        </div>
      </div>
    </footer>
  );
}
